import React from "react";
import * as styles from "./menu.css";

interface MenuProps {
  title: string;
  japaneseTitle: string;
  description: string;
  imageSrc: string;
  onClick: () => void;
}

export const Menu: React.FC<MenuProps> = ({
  title,
  japaneseTitle,
  description,
  imageSrc,
  onClick,
}) => {
  return (
    <div className={styles.menuContainer} onClick={onClick}>
      <div
        className={styles.menuContent}
        style={{ backgroundImage: `url(${imageSrc})` }}
      >
        <div className={styles.menuOverlay} />
        <div className={styles.titleContainer}>
          <h3 className={styles.menuTitle}>{title}</h3>
          <p className={styles.menuJapaneseTitle}>{japaneseTitle}</p>
        </div>
        {description && (
          <p className={styles.menuDescription}>{description}</p>
        )}
        <div className={styles.decorativeBorder} />
      </div>
    </div>
  );
};
